/**************************************************************************************************/
/*   File: /src/app/egov/egov.service.ts                                                          */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed Jul 31 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthLanguageCode, EgovAuthConfiguration, User } from '@siag/js-egov-authentication';
import { EGovAuthModule } from '@siag/ng6p-egov-authentication';

import { environment } from '../../environments/environment';
import { of, Observable } from 'rxjs';
import { HeaderService } from '../shared/services/utils/header.service';
import { EnvironmentPrefix } from '@siag/js-egov-authentication/src/environmentPrefix';

/**
 * The egov service
 */
@Injectable()
export class EgovService {

  /**
   * The user current
   */
  private userCurrent$: Observable<User>;
  /**
   * The user current sync
   */
  private userCurrent;
  /**
   * The widget configuration
   */
  widgetConfig: EgovAuthConfiguration;

  /**
   * The constructor
   * @param http The http 
   * @param logger The logger
   */
  constructor(private http: HttpClient, private logger: NGXLogger, private headerService: HeaderService) {
    
    this.widgetConfig = {
      // language: <AuthLanguageCode>'it',
      allowDelegationChange: true,
      apiPrefix: environment.iamApiPrefix,
      environment: environment.name as EnvironmentPrefix,
      httpLibrary: undefined
    };
    
    
    // In debug set impersonification
    if (!environment.production) {
      // FIXME WARNING DEBUG
     this.widgetConfig.userUrl = '/assets/mock/user-authenticated.json';
    }
    EGovAuthModule.Configure(this.widgetConfig, http);
    this.userCurrent$ = EGovAuthModule.GetCurrent();
  }

  /**
   * Set the widget language
   * @param language The language
   */
  setWidgetLanguage(language: string) {
    this.logger.trace('Changing egov language', language);
    this.widgetConfig.language = language.toLowerCase() as AuthLanguageCode;
    EGovAuthModule.Configure(this.widgetConfig, this.http);
  }

  /**
   * Clear the cache
   */
  clearCache() {
    this.userCurrent$ = null;
    return this;
  }

  /**
   * Return the current user
   */
  getCurrent() {
    if (this.userCurrent$) {
      return this.userCurrent$;
    } else {
      this.userCurrent$ = EGovAuthModule.GetCurrent();
      // FIXME mocked
      // return of(undefined);
      return this.userCurrent$;
    }
  }

 


}
